// For Megamenu snippets/mega-menu-tea
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".mega-menu").forEach( function (menu) {
        const tabBtns = menu.querySelectorAll('.mega-menu__tab-btn');
        const panels = menu.querySelectorAll('.mega-menu__tab-panel');
        
        tabBtns.forEach(function (btn) {
           btn.addEventListener("click", function(){
                const target = btn.dataset.tab;
                tabBtns.forEach( (b) => b.classList.remove("is-active"));
                panels.forEach( (p) => p.classList.remove("is-active"));

                btn.classList.add('is-active');
                const panel = menu.querySelector(`[data-panel="${target}"]`);
                if (panel) panel.classList.add('is-active');

           });
        });
    });
});

// mobile toogle button
class MobileNavigation extends HTMLElement{
    constructor(){
        super();

        this.overlay = this.querySelector('[data-mobile-nav-overlay]');
        this.drawer = this.querySelector('[data-mobile-nav-drawer]');
        this.closeBtn = this.querySelector('[data-mobile-nav-close]');

        this.openBtn = document.querySelector('[data-mobile-nav-open]');// in header.liquid

        this.openBtn?.addEventListener('click', () => this.open());
        this.closeBtn?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());

        document.addEventListener('keydown', (e) => {
            if(e.key === 'Escape') this.close();
        });


        this.querySelectorAll('.mobile__navigation__toggle').forEach( (btn) => {
            btn.addEventListener('click', (e) => {
                // e.preventDefault();
                const item = btn.closest('.mobile__navigation__item');
                const isExpanded = item.classList.toggle('is-expanded');

                btn.setAttribute('aria-expanded', isExpanded);
            });
        });
    }

    open(){
        this.classList.add('is-open');
        this.drawer.classList.add('is-open');
       // this.overlay.classList.add('is-open');
        this.openBtn.classList.add('is-open');
        document.body.style.overflow = 'hidden';
    }

    close(){
        this.openBtn.classList.remove('is-open');
        this.drawer.classList.remove('is-open');
        //this.overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(() => {
            this.classList.remove('is-open');
        },350);
    }    
}

customElements.define('mobile-navigation', MobileNavigation);


class SocialMediaTrends extends HTMLElement {
  constructor() {
    super();
    this.data = JSON.parse(this.querySelector('[data-social-trends-data]').textContent);
    this.modal = this.querySelector('[data-video-modal]');
    this.mediaEl = this.querySelector('[data-modal-media]');
    this.usernameEl = this.querySelector('[data-modal-username]');
    this.platformBadgeEl = this.querySelector('[data-modal-platform-badge]');
    this.linkEl = this.querySelector('[data-modal-link]');
    this.platformNameEl = this.querySelector('[data-modal-platform-name]');
    this.productListEl = this.querySelector('[data-modal-product-list]');

    this.querySelectorAll('[data-video-trigger]').forEach((btn) => {
      btn.addEventListener('click', () => this.openModal(parseInt(btn.dataset.index)));
    });

    this.querySelectorAll('[data-modal-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.closeModal());
    });

    document.addEventListener('keydown', (e) => e.key === 'Escape' && this.closeModal());

    // scroller arrows (giữ nguyên như trước)
    this.scroller = this.querySelector('[data-social-scroller]');
    this.querySelector('.social-trends__arrow--prev')?.addEventListener('click', () => this.scroll(-1));
    this.querySelector('.social-trends__arrow--next')?.addEventListener('click', () => this.scroll(1));
  }

  scroll(direction) {
    const cardWidth = this.scroller.querySelector('.social-trends__card')?.offsetWidth || 260;
    this.scroller.scrollBy({ left: direction * (cardWidth + 16), behavior: 'smooth' });
  }

  openModal(index) {
    const item = this.data[index];
    if (!item) return;

    // Media
    this.mediaEl.innerHTML = item.isVideo
      ? `<video src="${item.video}" autoplay loop muted playsinline class="social-trends__modal-video"></video>`
      : `<img src="${item.video}" alt="" class="social-trends__modal-image">`;

    // Header
    this.usernameEl.textContent = item.username;
    this.platformBadgeEl.textContent = item.platform === 'tiktok' ? 'TikTok' : 'Instagram';
    this.platformBadgeEl.className = `social-trends__platform-badge social-trends__platform-badge--${item.platform}`;
    this.platformNameEl.textContent = item.platform === 'tiktok' ? 'TikTok' : 'Instagram';
    this.linkEl.href = item.videoLink || '#';

    // Products
    this.productListEl.innerHTML = item.products.map((p, i) => `
      <div class="social-trends__modal-product">
        <img src="${p.image}" alt="${p.title}" width="80" height="80">
        <div class="social-trends__modal-product-info">
          <p class="social-trends__modal-product-title">${p.title}</p>
          <p class="social-trends__modal-product-price">${p.price}</p>
          <div class="social-trends__modal-product-actions">
            <div class="social-trends__qty-stepper">
              <button type="button" data-qty-minus>−</button>
              <input type="number" value="1" min="1" data-qty-input>
              <button type="button" data-qty-plus>+</button>
            </div>
            <button
              type="button"
              class="social-trends__add-to-cart"
              data-variant-id="${p.variantId}"
              ${!p.available ? 'disabled' : ''}
            >
              ${p.available ? 'In den Warenkorb' : 'Ausverkauft'}
            </button>
          </div>
        </div>
      </div>
    `).join('');

    this.bindProductActions();

    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  bindProductActions() {
    this.productListEl.querySelectorAll('.social-trends__modal-product').forEach((row) => {
      const input = row.querySelector('[data-qty-input]');
      row.querySelector('[data-qty-minus]').addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value) - 1);
      });
      row.querySelector('[data-qty-plus]').addEventListener('click', () => {
        input.value = parseInt(input.value) + 1;
      });

      const addBtn = row.querySelector('.social-trends__add-to-cart');
      addBtn.addEventListener('click', () => this.addToCart(addBtn, input.value));
    });
  }

  async addToCart(btn, quantity) {
    const variantId = btn.dataset.variantId;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: parseInt(quantity) }] })
      });

      if (!res.ok) throw new Error('Add to cart failed');

      btn.textContent = 'Hinzugefügt ✓';
      document.dispatchEvent(new CustomEvent('cart:updated'));

      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    } catch (err) {
      btn.textContent = 'Fehler';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  }

  closeModal() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
    this.mediaEl.querySelector('video')?.pause();
  }
}

customElements.define('social-media-trends', SocialMediaTrends);

// For button sticky add to cart on mobile
// For button sticky add to cart on mobile
document.addEventListener("DOMContentLoaded", function() {
  //var buyBox = document.getElementById('ProductBuyBox');
  var stickyBar = document.getElementById('ProductStickyBar');
  var stickyButton = document.getElementById('ProductStickyAddButton');
  var realButton = document.getElementById('ProductSubmitButton');

  if ( !stickyBar || !stickyButton || !realButton) return;

  // Đưa sticky bar ra làm con trực tiếp của <body> — tránh trường hợp
  // 1 phần tử cha nào đó có transform/filter/will-change khiến
  // position: fixed bị neo sai chỗ (không theo viewport nữa).
  document.body.appendChild(stickyBar);

  // Sticky button chỉ "hộ tống" click tới nút thật bên trong <product-form>,
  // để tận dụng nguyên logic AJAX + quantity đã có, không viết lại.
  stickyButton.addEventListener('click', function () {
    realButton.click();
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(realButton);
  }
});

//for mobile navigation dropdow in mobile
document.querySelectorAll(
  '.mobile__navigation__item.has-mega-menu > .mobile__navigation__item--row'
).forEach((row) => {
  row.addEventListener('click', (event) => {
    // event.preventDefault();

    const item = row.closest('.mobile__navigation__item');

    item.classList.toggle('is-open');
  });
});

window.addEventListener('keydown', e => setTimeout(() => console.log('bị chặn:', e.defaultPrevented, e.target), 0));

// add custom fee for cold products
/* ===== Isopack tự động theo hàng lạnh ===== */
(function () {
  'use strict';

  // ---- Cấu hình ----
  var ISOPACK_VARIANT_ID = 55234445869394;   // THAY bằng variant ID của Isopack
  var COLD_TYPE = 'Frozen Food';            // Product type của hàng lạnh (phải khớp chính xác)

  // ---- Gốc của fetch/XHR, dùng cho request của chính script để không bị lặp ----
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var timer = null;

  function jsonPost(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isCold(item) {
    return item.product_type === COLD_TYPE;
  }

  function isIsopack(item) {
    return item.variant_id === ISOPACK_VARIANT_ID;
  }

  // Cập nhật giao diện giỏ hàng sau khi script thay đổi giỏ
  function refreshUI() {
    if (typeof window.refreshCartDrawer === 'function') {
      window.refreshCartDrawer();        // tự định nghĩa hàm này nếu theme bạn có drawer
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (location.pathname === '/cart') {
      location.reload();
    }
  }

  // Đồng bộ Isopack với nội dung giỏ. Trả về Promise<boolean>: true nếu giỏ đã thay đổi
  function sync() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return getCart()
      .then(function (cart) {
        var hasCold = cart.items.some(isCold);
        var iso = cart.items.filter(isIsopack)[0];

        if (hasCold && !iso) {
          return jsonPost('/cart/add.js', { items: [{ id: ISOPACK_VARIANT_ID, quantity: 1 }] })
            .then(function () { return true; });
        }
        if (hasCold && iso && iso.quantity !== 1) {
          return jsonPost('/cart/change.js', { id: iso.key, quantity: 1 })
            .then(function () { return true; });
        }
        if (!hasCold && iso) {
          return jsonPost('/cart/change.js', { id: iso.key, quantity: 0 })
            .then(function () { return true; });
        }
        return false;
      })
      .catch(function (e) {
        console.error('[Isopack] sync lỗi:', e);
        return false;
      })
      .then(function (changed) {
        busy = false;
        if (changed) refreshUI();
        return changed;
      });
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 300);
  }

  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // ---- Bắt request giỏ hàng bằng fetch ----
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (!busy && CART_URL.test(url)) {
      p.then(scheduleSync, function () {});
    }
    return p;
  };

  // ---- Bắt request giỏ hàng bằng XMLHttpRequest (phòng khi theme dùng XHR) ----
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_URL.test(url)) {
      this.addEventListener('load', function () { if (!busy) scheduleSync(); });
    }
    return nativeOpen.apply(this, arguments);
  };

  // ---- Chặn lần cuối khi bấm Checkout ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]'
    );
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    sync().then(function () { window.location.href = '/checkout'; });
  }, true);

  // ---- Chạy khi tải trang ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();